import * as React from 'react';

import * as style from './styles.css';

export interface IFixedBlockProps {
  top: number;
  children: React.ReactElement;
}

export const FixedBlock: React.FC<IFixedBlockProps> = ({ top = 0, children }) => {
  return (
    <div data-testid="FixedBlock" style={{ top }} className={style['layout']}>
      {children}
    </div>
  );
};
